/**
 * React Query hooks for Notifications
 */

import { useQuery, useQueryClient } from "@tanstack/react-query";
import { notificationService } from "../services/notification.service";
import type { NotificationCountResponse } from "../types";

export const useNotificationCount = (firmId?: number) => {
  return useQuery<NotificationCountResponse>({
    queryKey: ["notification", "count", firmId],
    queryFn: () => notificationService.getNotificationCount(firmId!),
    enabled: !!firmId,
    staleTime: 1 * 60 * 1000, // 1 minute - notifications should be relatively fresh
    refetchInterval: 5 * 60 * 1000, // Refetch every 2 minutes
  });
};

/**
 * Hook to mark notifications as read and refresh count
 */
export const useMarkNotificationsAsRead = () => {
  const queryClient = useQueryClient();

  return async (firmId: number, mode: 1 | 2) => {
    await notificationService.markNotificationsAsRead(firmId, mode);
    // Invalidate and refetch notification count
    await queryClient.invalidateQueries({ queryKey: ["notification", "count", firmId] });
  };
};

